import { MtnaDataType } from '@mtna/data-core-ui';
import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsFilterType } from '../models/filter/filter-type.model';
import { RdsDataTypeUtil } from './data-type-util';

export class RdsFilterUtil {
  /**
   * Given a variable, determine the appropraite filter type
   * @param variable Variable to determine the filter type
   * @returns the filter type for the given variable
   */
  static determineType<V extends Variable | VariableSummary = Variable>(variable: V): RdsFilterType | null {
    if (!variable) {
      return null;
    }

    const hasClassification = !!variable.classificationUri || !!(variable as VariableSummary).classificationId;
    if (hasClassification) {
      return 'CODE';
    }

    if (variable.dataType === 'DATE') {
      return 'DATE';
    }

    if (RdsDataTypeUtil.simplifyMtnaDataType(variable.dataType as MtnaDataType) === 'TEXT') {
      return 'TEXT';
    }

    if (RdsDataTypeUtil.simplifyMtnaDataType(variable.dataType as MtnaDataType) === 'NUMERIC') {
      return 'NUMERIC';
    }

    console.warn(`[@mtna/rds-lib-ui][RdsFilterUtil] - could not determine type of `, variable);
    return null;
  }
}
